import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
} from '../../themes'

export const Style = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0 25px;
  
  .header-thankyou {
    top: 15px;
    left: 15px;
    position: absolute;

    > img {
      width: 80px;
    }
  }

  .content-thankyou {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 310px;

    > .title {
      text-align: center;

      font-family: LibreBaskervilleBold;
      font-size: ${FONT_SIZE.LG};
      color: ${COLOR.BLACK};
    }

    > .status {
      height: 40px;
      margin-top: 25px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      
      color: ${COLOR.BLACK};
      font-size: ${FONT_SIZE.XXS};
      background-color: ${({ isAccepted }) => isAccepted ? COLOR.GOLD_3 : COLOR.GRAY_22};

      > span {
        font-size: ${FONT_SIZE.XXS};
        font-weight: bold;
        color: ${COLOR.BLACK};
      }
    }

    > .detail {
      margin-top: 25px;

      text-align: center;
      font-size: ${FONT_SIZE.XXS};
      line-height: ${FONT_SIZE.MD};

      > span {
        font-size: ${FONT_SIZE.XXS};
        font-weight: bold;
        color: ${COLOR.BLACK};
      }
    }

    > .footer-thankyou {
      bottom: 30px;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;

      width: 100%;
      max-width: 310px;

      text-align: center;
      line-height: ${FONT_SIZE.XXS};
      color: ${COLOR.BLACK};
      font-size: ${FONT_SIZE.MN};
    }
  }

  @media screen and (min-width: 768px) {
    .content-thankyou {
      max-width: 536px;

      > .footer-thankyou {
        max-width: 536px;
      }
    }
  }
`
